import React from 'react'
import FeedBackSectionalForTeacher from '../components/MT_Score/FeedBackSectionalForTeacher'
import ScoreViewHeaderForTeacher from '../components/MT_Score/ScoreViewHeaderForTeacher'

const MtScoreFeedbackSectionalForTeacher = () => {
  return (
    <>
  <ScoreViewHeaderForTeacher />
    <FeedBackSectionalForTeacher />
    </>
  )
}

export default MtScoreFeedbackSectionalForTeacher